import React from 'react';
import {Link} from 'react-router';
import Button from '@material-ui/core/Button';
import './NoUpcomingReviewsReady.styl';
import {dashV2Path} from 'components/StatsPage2.utils';

const summaryPath = sessionUser => {
  // if admin, take them to the exec my coaching, otherwise mgr coaching summary
  return sessionUser.isAdmin()
    ? `/${dashV2Path}/admin/${sessionUser.id}/coaching-plans?tabIndex=1`
    : `/${dashV2Path}/manager/${sessionUser.id}/coaching-plans`;
};

/**
 * Oversize card that's rendered in the upcoming agenda summary's ready column when there are no
 * upcoming reviews that are ready to start.
 *
 */
export default class NoUpcomingReviewsReady extends React.PureComponent {
  render() {
    const {sessionUser} = this.props;
    return (
      <div className="no-upcoming-reviews-ready">
        <strong>No meetings scheduled</strong>
        <div>
          <div className="view-link">
            <Button
              variant="text"
              component={Link}
              className="generic-link"
              to={summaryPath(sessionUser)}>
              View Coaching Plans
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
